import { useTranslation } from "react-i18next";
import { ContactUpdateInquiriesDefaultEndPage } from "./ContactUpdateInquiriesDefaultEndPage";

export const ContactUpdateInquiriesDeleteSuccessPage = () => {
	const { t } = useTranslation();

	return (
		<ContactUpdateInquiriesDefaultEndPage
			headline={t("Deletion request submitted")}
			text={t("The deletion request has been sent to our employees. We will process it as quickly as possible.")}
		/>
	);
};
